import { Pipe, PipeTransform } from '@angular/core';

import { userActiveProductIds } from '../constants/constants';

@Pipe({ name: 'hasUserProductType', standalone: true })
export class HasUserProductTypePipe implements PipeTransform {
  transform(
    section,
    productType,
    productList,
    areAllProductsSelected,
    userServiceUserData
  ): boolean {
    if (areAllProductsSelected[section]) {
      return true;
    }
    const productIds = userActiveProductIds(section, userServiceUserData);
    for (const product of productList[productType]) {
      if (productIds.indexOf(product.id) >= 0) {
        return true;
      }
    }
    return false;
  }
}
